import React from 'react';
import {
  Boxes,
  Factory,
  Landmark,
  ShoppingCart,
  Truck,
  Warehouse,
} from 'lucide-react';

const capabilities = [
  {
    title: 'Advanced Manufacturing',
    description:
      'Plan, schedule, and control complex manufacturing operations with confidence.',
    icon: Factory,
  },
  {
    title: 'Supply Chain Management',
    description:
      'Connect demand, purchasing, inventory, and fulfillment across global operations.',
    icon: Boxes,
  },
  {
    title: 'Financial Management',
    description:
      'Improve costing, budgeting, accounting, and financial visibility in one platform.',
    icon: Landmark,
  },
  {
    title: 'Distribution & Logistics',
    description:
      'Coordinate order flow, logistics, and distribution processes with greater accuracy.',
    icon: Truck,
  },
  {
    title: 'Procurement & Purchasing',
    description:
      'Standardize sourcing, approvals, supplier collaboration, and purchasing workflows.',
    icon: ShoppingCart,
  },
  {
    title: 'Warehouse & Inventory',
    description:
      'Increase inventory accuracy and keep warehouse movements visible and efficient.',
    icon: Warehouse,
  },
];

const CapabilityCard = ({ icon: Icon, title, description }) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      borderColor: 'rgba(15, 23, 42, 0.08)',
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{
        backgroundColor: 'rgba(216, 24, 32, 0.08)',
        color: '#D81820',
      }}
    >
      <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
    </div>

    <h3
      className="mb-3 text-lg font-bold leading-snug"
      style={{ color: '#1A2634' }}
    >
      {title}
    </h3>

    <p
      className="mt-auto text-sm font-medium leading-6"
      style={{ color: '#334155', textAlign: 'left' }}
    >
      {description}
    </p>
  </article>
);

const M3Capabilities = () => {
  return (
    <section
      aria-labelledby="m3-capabilities-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="m3-capabilities-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Infor M3 Capabilities
        </h2>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((capability) => (
            <CapabilityCard key={capability.title} {...capability} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default M3Capabilities;
